import { ASSET_METADATA_STALE_TIME } from "~/v2/constants";
import { queryKeys } from "../queryKeys";
import { type Asset, getAsset } from "../rest";
import useRequest, { type QueryOptions } from "./useRequest";

export const useGetAsset = ({
  symbol,
  options,
}: {
  symbol: string;
  options?: QueryOptions<Asset>;
}) => {
  const { data, refetch, isFetched, isError, error } = useRequest(
    queryKeys.assets.detail(symbol),
    () => getAsset(symbol),
    {
      ...options,
      gcTime: 9999999,
      staleTime: ASSET_METADATA_STALE_TIME,
      refetchInterval: false,
    },
  );

  return { asset: data, refetch, isFetched, isError, error };
};

export default useGetAsset;
